import { datadogRum } from '@datadog/browser-rum';
import axios from 'axios';
import { ApiEndpoints } from '@utils/endpoints';

interface IUpdatePhoto {
	image: string;
	imageType: 'Selfie' | 'Photo ID';
	authorizationToken: string;
	handleError?: (error: any) => void;
	callback?: () => void;
}

type UpdatePhotoFunction = ({
	image,
	imageType,
	authorizationToken,
	handleError,
	callback,
}: IUpdatePhoto) => Promise<{
	photo: string;
}>;

const updatePhoto: UpdatePhotoFunction = async ({
	image,
	imageType,
	authorizationToken,
	handleError = () => {},
	callback = () => {},
}) => {
	const getEndpoint = () => {
		const endpoints = { Selfie: 'selfie', 'Photo ID': 'id' };
		return `/image/${endpoints[imageType]}Image`;
	};

	const endpoint = getEndpoint();

	const blob = await (await fetch(image)).blob();
	const photo = URL.createObjectURL(blob);

	await axios
		.put(`${ApiEndpoints.memberPortal}${endpoint}`, blob, {
			headers: {
				authorizationToken,
				'Content-Type': blob.type,
			},
		})
		.then(() => {
			callback();
		})
		.catch((error: any) => {
			datadogRum.addError(error);
			handleError(error);
		});

	return { photo };
};

export default updatePhoto;
